import React, { useCallback, useState, useEffect } from "react";
import {
  AppProvider,
  Card,
  FormLayout,
  Button,
  Image,
  TextField,
  Link,
  Toast,
  Modal,
  Text,
  InlineError,
} from "@shopify/polaris";
import axios from "axios";
import axios2 from "../../Assets/Lib/axios.js";
import Cookies from "js-cookie";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";
import {
  accessCrm,
  accessDashboard,
  accessNavigation,
  accessUiText,
  accessViewBlogs,
  accessViewPages,
  adminRole,
} from "../../Helpers";

function Login() {
  // const [logo, setLogo] = useState("");
  // useEffect(() => {
  //   import(`../../Assets/Images/${process.env.REACT_APP_CLIENT}-logo.svg`).then(
  //     (module) => setLogo(module.default)
  //   );
  // }, []);

  const client = process.env.REACT_APP_CLIENT;
  const logo = `/logos/${client}-logo.svg`;
  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get("cms-accesstoken");
    if (token && token !== "null") {
      navigate("/admin/competitors");
    }
  }, []);
  const [emailValue, setEmailValue] = useState(
    localStorage.getItem("savedEmail") || ""
  );
  const [passwordValue, setPasswordValue] = useState(
    localStorage.getItem("savedPassword") || ""
  );
  const [emailError, setEmailError] = useState("");
  const [passwordError, setrPasswordError] = useState("");
  const [active, setActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRecaptchaChecked, setIsRecaptchaChecked] = useState(false);
  const [error, setError] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const handleEmailFieldChange = useCallback((value) => {
    setEmailValue(value);
    localStorage.setItem("savedEmail", value);
    setEmailError("");
  }, []);
  const handlePasswordFieldChange = useCallback((value) => {
    setPasswordValue(value);
    localStorage.setItem("savedPassword", value);
    setrPasswordError("");
  }, []);
  const toastMarkup = active ? (
    <Toast
      content="These credentials do not match our records."
      onDismiss={toggleActive}
    />
  ) : null;

  function onChange(value) {
    console.log(value);
    setCaptchaValue(value);
    setIsRecaptchaChecked(true);
    setError("");
  }

  const [viewedMenuSections, setViewedMenuSections] = useState([]);

  return (
    <AppProvider>
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "40%",
          transform: "translate(-50%, -50%)",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <img src={logo} alt="Logo" />

        <div style={{ minWidth: 400, marginTop: 20 }}>
          <div style={{ marginBottom: 30 }}>
            <Text variant="heading2xl" as="h3">
              Login
            </Text>
          </div>

          <FormLayout>
            <Card sectioned>
              <FormLayout>
                <TextField
                  type="email"
                  label="Email"
                  value={emailValue}
                  onChange={handleEmailFieldChange}
                  error={emailError}
                />
                <div onKeyDown={handleKeyPress}>
                  <TextField
                    label="Password"
                    value={passwordValue}
                    onChange={handlePasswordFieldChange}
                    type="password"
                    error={passwordError}
                  />
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                    onChange={onChange}
                  />
                </div>
                {error ? <InlineError message={error} /> : null}

                <Button
                  variant="primary"
                  fullWidth
                  onClick={handleSignIn}
                  loading={isLoading}
                >
                  Sign in
                </Button>
              </FormLayout>
            </Card>
            <div>
              <div style={{ float: "left" }}>
                <p style={{ float: "left" }}>
                  {"© Copyright " +
                    new Date().getFullYear() +
                    " " +
                    process.env.REACT_APP_CLIENT_NAME}
                </p>
                <br />
              </div>
              <div style={{ float: "right" }}></div>
            </div>
          </FormLayout>
        </div>
        {toastMarkup}
      </div>
    </AppProvider>
  );

  function handleSignIn(e) {
    Cookies.set("ghiwa1", "aaa,", { secure: true });
    // console.log("testghiwa=", Cookies.get("ghiwa1"));
    if (
      !emailValue ||
      (emailValue &&
        !emailValue.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) ||
      !passwordValue ||
      !isRecaptchaChecked
    ) {
      if (!emailValue) {
        setEmailError("Please enter your email");
      }
      if (
        emailValue &&
        !emailValue.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
      ) {
        setEmailError("Please enter a valid email");
      }
      if (!passwordValue) {
        setrPasswordError("Please enter your password");
      }
      if (!isRecaptchaChecked) {
        setError("Please verify that you are not a robot.");
      }
    } else {
      setIsLoading(true);
      const form_data = new FormData();
      form_data.append("email", emailValue);
      form_data.append("password", passwordValue);
      console.log("captchaValue=", captchaValue);
      form_data.append("g-recaptcha-response", captchaValue);
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/login`, form_data)
        .then((res) => {
          const current = new Date();
          current.setDate(current.getDate() + 7);
          Cookies.set("cms-accesstoken", res.data.data.token, {
            expires: current,
            secure: true,
          });
          res?.data?.data?.user?.first_name &&
            res?.data?.data?.user?.last_name &&
            Cookies.set(
              "cms-name",
              res.data.data.user.first_name +
                " " +
                res.data.data.user.last_name,
              {
                expires: current,
                secure: true,
              }
            );
          Cookies.set("cms-permissions", res.data.data.permissions, {
            expires: current,
            secure: true,
          });

          Cookies.set(
            "cms-admin-role",
            res.data.data.role[0] ? "Super" : "Custom",
            {
              expires: current,
              secure: true,
            }
          );
          console.log("accessDashboard()", accessDashboard());

          let array = [];
          axios2
            .get(`/settings/display-content`)
            .then((result) => {
              if (result?.data.data?.length) {
                parseInt(result?.data?.data[1].main_menu?.dashboard) &&
                  array.push("dashboard");
                parseInt(result?.data?.data[1].main_menu?.pages) &&
                  array.push("pages");
                parseInt(result?.data?.data[1].main_menu?.blogs) &&
                  array.push("blogs");
                parseInt(result?.data?.data[1].main_menu?.ui_text) &&
                  array.push("ui");
                parseInt(result?.data?.data[1].main_menu?.navigation) &&
                  array.push("navigation");
                parseInt(result?.data?.data[1].main_menu?.crm) &&
                  array.push("crm");
                console.log("array=", array);
                //setViewedMenuSections(array);
              } else {
                console.log("");
              }

              // if (accessDashboard()) {
              //   navigate("admin/dashboard");
              // } else if (accessViewPages()) {
              //   navigate("admin/pages");
              // } else if (accessViewBlogs()) {
              //   navigate("admin/blogs");
              // } else if (accessUiText()) {
              //   navigate("admin/ui-text");
              // } else if (accessNavigation()) {
              //   navigate("admin/navigation");
              // } else if (accessCrm()) {
              //   navigate("admin/crm");
              // } else {
              //   navigate("admin/settings/languages");
              // }
              // if (
              //   accessDashboard() &&
              //   (array.includes("dashboard") || !array.length)
              // ) {
              //   navigate("admin/dashboard");
              // } else if (
              //   accessViewPages() &&
              //   (array.includes("pages") || !array.length)
              // ) {
              //   navigate("admin/pages");
              // } else if (
              //   accessViewBlogs() &&
              //   (array.includes("blogs") || !array.length)
              // ) {
              //   navigate("admin/blogs");
              // } else if (
              //   accessUiText() &&
              //   (array.includes("ui") || !array.length)
              // ) {
              //   navigate("admin/ui-text");
              // } else if (
              //   accessNavigation() &&
              //   (array.includes("navigation") || !array.length)
              // ) {
              //   navigate("admin/navigation");
              // } else if (
              //   accessCrm() &&
              //   (array.includes("crm") || !array.length)
              // ) {
              //   navigate("admin/crm");
              // } else {
              //   navigate("admin/settings/languages");
              // }
              navigate("admin/competitors");
            })
            .catch((err) => console.log(err));
          // navigate('')

          // navigate(
          //   accessDashboard()
          //     ? "admin/dashboard"
          //     : accessViewPages()
          //     ? "admin/pages"
          //     : accessUiText()
          //     ? "admin/ui-text"
          //     : accessNavigation()
          //     ? "admin/navigation"
          //     : accessCrm()
          //     ? "admin/crm/contacts"
          //     : "admin/settings/languages"
          // );
        })
        .catch(function (error) {
          window.grecaptcha.reset();
          setIsRecaptchaChecked(false);
          setIsLoading(false);
          setError("Invalid email or password");
        });
    }
  }

  function toggleActive() {
    setActive((active) => !active);
  }
  function handleKeyPress(event) {
    const enterKeyPressed = event.keyCode === 13;
    if (enterKeyPressed) {
      handleSignIn();
    }
  }
}
export default Login;
